export default "__VITE_ASSET__7ed55a34__"